import { RaidHistoryEntry } from "types/web-app";
import { StandardFrame } from "../ui/frames/standard-frame";
import React from "react";

interface RaidHistoryCardProps {
  raid: RaidHistoryEntry;
}

export const RaidHistoryCard: React.FC<RaidHistoryCardProps> = ({ raid }) => {
  const isVictory = raid.outcome === "VICTORY";

  const date = new Date(raid.timestamp).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <StandardFrame
      variant={isVictory ? "green" : "red"}
      className="w-full flex flex-col gap-2"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className={`font-bold text-sm uppercase px-2 py-0.5 rounded ${
              isVictory ? "bg-pk-blue-4 text-white" : "bg-pk-red-4 text-white"
            }`}
          >
            {raid.outcome || "IN PROGRESS"}
          </span>
          <span className="text-pk-gray-4 text-xs font-bold">
            {raid.raid_name}
          </span>
          <span className="text-pk-gray-3 text-xs capitalize">
            ({raid.difficulty})
          </span>
        </div>
        <span className="text-pk-gray-5 text-xs font-bold">{date}</span>
      </div>

      {raid.rewards && (
        <div className="flex items-center gap-4 text-xs text-pk-gray-4">
          <span>+{raid.rewards.coins} coins</span>
          <span>+{raid.rewards.xp} XP</span>
          {raid.rewards.boss_drops.length > 0 && (
            <span className="text-pk-yellow-4">
              Drops: {raid.rewards.boss_drops.join(", ")}
            </span>
          )}
        </div>
      )}
    </StandardFrame>
  );
};















